import { useCallback, useRef } from "react";
import { useLatestRef } from "./use-latest-ref";

export const useRequestAnimationFrame = (callback: () => void) => {
  const frame = useRef(0);
  const latestCallbackRef = useLatestRef(callback);

  const updateOnNextFrame = useCallback(() => {
    cancelAnimationFrame(frame.current);

    frame.current = requestAnimationFrame(latestCallbackRef.current);
  }, [latestCallbackRef]);

  return updateOnNextFrame;
};
